import React from 'react';

export const SelectedSvg: React.FunctionComponent = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="7" fill="#0D99D6" />
    <path d="M4 7L6 9L10 5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
